export enum SupportPanelState {
  help = 'help',
  basic = 'basic',
  solution = 'solution',
  detail = 'detail',
  confirmation = 'confirmation',
  none = 'none',
}
